// BellCurveChart.jsx

import React from 'react';
import { VictoryChart, VictoryArea, VictoryLabel, VictoryAxis } from 'victory';

const BellCurveChart = ({
  data = [],
  title = "Distribution",
  xLabel = "Value",
  yLabel = "Frequency (%)"
}) => {

  /* ---------- NORMALIZE INPUT ---------- */

  const normalizeValue = (value) => {

    // number
    if (typeof value === "number") return value;

    if (typeof value === "string") {

      const trimmed = value.trim();

      // time format (6:10 AM)
      if (trimmed.includes(":")) {
        const [timePart] = trimmed.split(" ");
        const [hours] = timePart.split(":").map(Number);
        return hours;
      }

      // numeric string
      if (!isNaN(trimmed)) {
        return Number(trimmed);
      }
    }

    return null;
  };

  /* ---------- CALCULATE FREQUENCY ---------- */

  // const calculateFrequency = () => {

  //   const frequencies = {};

  //   data.forEach((item) => {

  //     const value = normalizeValue(item);

  //     if (value === null) return;

  //     const bucket = Math.floor(value);

  //     if (frequencies[bucket]) {
  //       frequencies[bucket]++;
  //     } else {
  //       frequencies[bucket] = 1;
  //     }

  //   });

  //   return frequencies;
  // };
  // const calculateFrequency = () => {
  //   const values = data
  //     .map(v => normalizeValue(v))
  //     .filter(v => v !== null);
  //   if (values.length === 0) return {};
  //   const min = Math.min(...values);
  //   const max = Math.max(...values);
  //   const binCount = Math.ceil(Math.sqrt(values.length)); 
  //   const binSize = (max - min) / binCount;

  //   const frequencies = {};
  //   values.forEach((v) => {
  //     const bin = Math.floor((v - min) / binSize);
  //     const bucket = Math.floor(min + bin * binSize);
  //     if (frequencies[bucket]) {
  //       frequencies[bucket]++;
  //     } else {
  //       frequencies[bucket] = 1;
  //     }
  //   });
  //   return frequencies;
  // };

  const calculateFrequency = () => {

    const values = data
      .map(v => normalizeValue(v))
      .filter(v => v !== null);

    if (values.length === 0) return {};

    const min = Math.min(...values);
    const max = Math.max(...values);
    const range = max - min;

    const frequencies = {};

    /* ---------- SMALL RANGE (original behaviour) ---------- */

    if (range <= 24) {

      values.forEach(v => {

        const bucket = Math.floor(v);

        if (frequencies[bucket]) {
          frequencies[bucket]++;
        } else {
          frequencies[bucket] = 1;
        }

      });

      return frequencies;
    }

    /* ---------- LARGE RANGE (binning) ---------- */

    const binCount = Math.ceil(Math.sqrt(values.length));
    const binSize = range / binCount;

    values.forEach(v => {

      const bin = Math.floor((v - min) / binSize);
      const bucket = Math.floor(min + bin * binSize);

      if (frequencies[bucket]) {
        frequencies[bucket]++;
      } else {
        frequencies[bucket] = 1;
      }

    });

    return frequencies;
  };

  /* ---------- GENERATE BELL CURVE POINTS ---------- */

  // const generateBellCurvePoints = () => {
  //   const frequencies = calculateFrequency();
  //   const total = data.length;

  //   const keys = Object.keys(frequencies).map(Number);

  //   if (keys.length === 0) return [];

  //   const min = Math.min(...keys);
  //   const max = Math.max(...keys);

  //   const points = [];

  //   for (let x = min; x <= max; x++) {
  //     const freq = frequencies[x] || 0;
  //     points.push({
  //       x,
  //       y: freq / total
  //     });
  //   }
  //   return points;
  // };
//   const generateBellCurvePoints = () => {

//   const frequencies = calculateFrequency();
//   const total = data.length;

//   const points = Object.keys(frequencies)
//     .map(Number)
//     .sort((a, b) => a - b)
//     .map((key) => ({
//       x: key,
//       y: frequencies[key] / total
//     }));

//   return points;
// };

  const generateBellCurvePoints = () => {
    const frequencies = calculateFrequency();
    const total = data.length;
    const points = Object.keys(frequencies)
      .map(Number)
      .sort((a, b) => a - b)
      .map((key) => ({
        x: key,
        y: frequencies[key] / total
      }));
    return points;
  };

  const bellCurveData = generateBellCurvePoints();

  return (
    <div className="text-white">
      <VictoryChart domainPadding={{ x: 20, y: 20 }}>
        {/* Title */}
        <VictoryLabel
          text={title}
          x={225}
          y={10}
          textAnchor="middle"
          style={{ fill: "white", fontSize: 14 }}
        />

        {/* X Axis */}
        <VictoryAxis
          label={xLabel}
          style={{
            axis: { stroke: "white" },
            tickLabels: { fill: "white" },
            axisLabel: { fill: "yellow" }
          }}
          labelComponent={<VictoryLabel dy={40} />}
        />

        {/* Y Axis */}
        <VictoryAxis
          dependentAxis
          label={yLabel}
          style={{
            axis: { stroke: "white" },
            tickLabels: { fill: "white" },
            axisLabel: { fill: "yellow" }
          }}
          labelComponent={<VictoryLabel dx={-40} />}
          domain={[0, 1]}
        />

        {/* Curve */}
        <VictoryArea
          data={bellCurveData}
          interpolation="natural"
          style={{
            data: { fill: "purple", stroke: "white" },
            labels: { fill: "white" }
          }}
          labelComponent={<VictoryLabel renderInPortal />}
          labels={({ datum }) => `${Math.round(datum.y * 100)}%`}
        />

      </VictoryChart>

    </div>
  );
};

export default BellCurveChart;